export default "__VITE_ASSET__DTjVBaDH__"